import { defineMessages } from 'react-intl';

export default defineMessages({
    integralSafetyComment: {
        id: 'components.projectInformation.integralSafety.integralSafetyComment',
        defaultMessage: 'Overall comment', // DE: Zusammenfassende Beurteilung
    },
});
